import 'expose-loader?$!expose-loader?jQuery!jquery';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import format from 'date-fns/format';

Vue.config.productionTip = false;

// variável global
Vue.prototype.$BASE_API = process.env.VUE_APP_BASE_API

import "overlayscrollbars/css/OverlayScrollbars.min.css";
import "@/assets/adminlte/css/adminlte.css";
//import "@/assets/font/font.css";
import "@/assets/custom.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "overlayscrollbars/js/jquery.overlayScrollbars.min.js";
import "jquery.inputmask/dist/jquery.inputmask.bundle.js";
import "@/assets/adminlte/js/adminlte.js";
import "@/assets/custom.js";

$('[data-inputmask]').inputmask();

$('body').popover({
  selector: '[rel="popover"]'
});

$('body').tooltip({
  selector: '[title]',
  container: 'section'
});


Vue.filter('formatDate', function(value) {
    if (value) {
        return format(new Date(value),'dd/MM/yyyy');
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return format(new Date(value),'dd/MM/yyyy HH:mm');
    }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');